import Cookies from 'universal-cookie';

export let filterByState = (data = [], state = '') => {
    if (data.length > 0 && state !== '') {
        data = data.filter(({ node }) => {
            let brokerState = node.stateCode;
            //console.log(brokerState.trim() == state.trim())
            return brokerState.trim() == state.trim();
        })
        return data;
    }
    return [];
}

export let fillByInterState = (data = [], state = '', showRecord = false) => {
    if (data.length > 0 && state !== '') {
        data = data.filter(({ node }) => {
            let brokerState = node.stateCode;
            showRecord = brokerState.trim() == state.trim();

            if (!showRecord)
                showRecord = node.interstate;

            return showRecord;

        })
        return data;
    }
    return [];
}

export let fillBrokerTiles = (data = [], postcodeParts = '', postcode = '', showRecord = false) => {
    if (data.length > 0) {
        data = data.filter(({ node }) => {
            let brokerState = node.stateCode;
            let broker_postcode = node.broker_postcode.split(",");
            showRecord = broker_postcode.indexOf(postcode) != -1;

            if (!showRecord) {
                let stateCode = '';
                if (postcodeParts.length == 3) {
                    stateCode = postcodeParts[2];
                    showRecord = brokerState.trim() == stateCode.trim();
                }
            }
            // if( !showRecord )
            //     showRecord = node.interstate;

            console.log(showRecord);
            return showRecord;
        });
        return data;
    }
    return [];
}

export let filterByInterState = (data = []) => {
    if (data.length > 0) {
        data = data.filter(({ node }) => {
            return node.interstate;
        })
        return data;
    }
    return [];
}


export const log = (logVar = '', separator = '-------') => {
    return false;
    console.log(separator)
    console.log(logVar)
    console.log(separator)
}

export const cookieWrite = (variable, value = '') => {
    let cookies = new Cookies();
    cookies.set(variable, value, { path: '/' });
    return cookies.get(variable)
}

export const cookieRead = (variable) => {
    let cookies = new Cookies();
    return cookies.get(variable)
}

export const oWindow = (() => {
    return {
        read: (readVar) => {
            if (typeof window != 'undefined') {
                return window.readVar;
            }
        },
        write: (writeVar = '', value = '') => {
            if (typeof window != 'undefined') {
                if (!!writeVar && !!value) {
                    window[writeVar] = value;
                    return !!window.writeVar;
                }
            }
        }
    }
})()

export const removeCookie = (removeVar = '') => {
    if (!!removeVar) {
        let cookies = new Cookies()
        cookies.remove(removeVar, { path: '/' })
    }
}

export const formatResponseTime = (responseTime) => {
    if (!responseTime) {
        return '1 min'; // default time according to new design
    } else {
        let parts = responseTime.split(" ");
        if (parts.length > 1) {
            if (parts[0] == '0') {
                return '1 min';
            } else {
                return parts[0] + ' ' + String(parts[1]);
            }
        } else {
            return '1 min';
        }
    }
}

// utils/animateNumber.js
// utils/animateNumber.js
export const animateNumber = (start, end, duration, callback, format = null) => {
    const range = end - start;
    const increment = range / (duration / 16); // Approx. 60 FPS
    let current = start;

    const updateCounter = () => {
        current += increment;
        if ((increment > 0 && current >= end) || (increment < 0 && current <= end)) {
            current = end; // Stop at the target value
            clearInterval(timer);
        }
        const formattedValue = format
            ? format(Math.round(current)) // Apply formatting if provided
            : Math.round(current);
        callback(formattedValue);
    };

    const timer = setInterval(updateCounter, 16); // Runs ~60 times per second
};

/**
 * Initialize animations when elements with the "animate" class appear in the viewport.
 */
export function initAnimations() {
    const animatedElements = document.querySelectorAll('.animate');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate'); // Trigger animation
                observer.unobserve(entry.target); // Stop observing after animation
            }
        });
    });

    animatedElements.forEach((el) => observer.observe(el));
}

/**
 * Utility function to throttle events like scroll for performance.
 */
export function throttle(callback, delay) {
    let lastTime = 0;
    return function (...args) {
        const now = Date.now();
        if (now - lastTime >= delay) {
            callback(...args);
            lastTime = now;
        }
    };
}

//let getReCaptchaKey="6LfkKwoTAAAAAFM0jzoiM17A61r7mO3d67rZnJu3"

// API keys for localhost and marketplace
let getReCaptchaKey = "6LfRz9oqAAAAAD5UwvLPUEyc5ZDiQ4N8aTml_jyB";
let getGoogleAPIKey = "6LcMydYqAAAAAPHrX8M4erSWMS6BDTd3KQ8mzFSI";
let getGoogleMapKey = "AIzaSyDhBtxHe8EwWQlmESHI-sAwMuLqZHGvK-E&v=3.exp";

// Check if running in a dev environment (localhost, 127.0.0.1, or marketplace.hashfinancialgroup.com)
const isDevEnvironment = (typeof window !== "undefined" && window.location.hostname) 
  ? (window.location.hostname === "localhost" || 
     window.location.hostname === "127.0.0.1" || 
     window.location.hostname === "staging-marketplace.hashfinancialgroup.com")
  : (typeof process !== "undefined" && process.env?.NODE_ENV === "development");

if (!isDevEnvironment) {
  getReCaptchaKey = "6Le7kdoqAAAAAL6m7VHG9hNVM1skvFYsvbFu_BPO";
  //getGoogleAPIKey = "6LcMydYqAAAAAPHrX8M4erSWMS6BDTd3KQ8mzFSI";
}

export const siteName = "HFG Marketplace";

// export const host = (typeof window !== "undefined" && window.location.hostname)
//   ? (window.location.hostname === "localhost" || 
//      window.location.hostname === "127.0.0.1" || 
//      window.location.hostname === "marketplace.hashfinancialgroup.com")
//     ? 'https://manage-marketplace.hashfinancialgroup.com/staging/1432/wp-json'
//     : 'https://manage-marketplace.hashfinancialgroup.com/wp-json'
//   : '';

export const host = (isDevEnvironment) ? 'https://manage-marketplace.hashfinancialgroup.com/staging/1432/wp-json' : 'https://manage-marketplace.hashfinancialgroup.com/wp-json';
//export const host = 'http://localhost/wordpress/wp-json';
//export const host = 'https://manage-marketplace.hashfinancialgroup.com/wp-json';
export const siteURL = (isDevEnvironment) ? 'https://staging-marketplace.hashfinancialgroup.com' : 'https://marketplace.hashfinancialgroup.com';

//Google keys
export const reCaptchaKey = getReCaptchaKey;
export const googleAPIKey = getGoogleAPIKey;
export const googleMapKey = getGoogleMapKey;

//Common variables
export const keySpecialities = [
    { name: 'Residential', value: '15', pin: false },
    { name: 'Refinance', value: '30', pin: false },
    { name: 'Asset Finance', value: '18', pin: false },
    { name: 'Business Finance', value: '21', pin: false },
    { name: 'Car Finance', value: '26', pin: false },
    { name: 'Cash-flow Finance', value: '22', pin: false },
    { name: 'Commercial Loan', value: '16', pin: false },
    { name: 'Debt Consolidation', value: '27', pin: false },
    { name: 'Bridging Loan', value: '24', pin: false },
    { name: 'Islamic Loan', value: '25', pin: false },
    { name: 'Non-conforming Loan', value: '17', pin: false },
    { name: 'Non-resident Loan', value: '29', pin: false },
    { name: 'Personal Loan', value: '28', pin: false },
    { name: 'Reverse mortgage Loan', value: '23', pin: false },
    { name: 'SMSF Loan', value: '19', pin: false },
]

export const optLanguages = [
    { name: "Afaan Oromoo", value: "Afaan Oromoo", pin: false },
    { name: "Afaraf", value: "Afaraf", pin: false },
    { name: "Afrikaans", value: "Afrikaans", pin: false },
    { name: "Akan", value: "Akan", pin: false },
    { name: "Albanian", value: "Albanian", pin: false },
    { name: "Arabic", value: "Arabic", pin: false },
    { name: "Armenian", value: "Armenian", pin: false },
    { name: "Assyrian", value: "Assyrian", pin: false },
    { name: "Asụsụ Igbo", value: "Asụsụ Igbo", pin: false },
    { name: "Avesta", value: "Avesta", pin: false },
    { name: "Aymar Aru", value: "Aymar Aru", pin: false },
    { name: "Bahasa Indonesia", value: "Bahasa Indonesia", pin: false },
    { name: "Bahasa Malaysia", value: "Bahasa Malaysia", pin: false },
    { name: "Bahasa Melayu", value: "Bahasa Melayu", pin: false },
    { name: "Bahasa", value: "Bahasa", pin: false },
    { name: "Bamanankan", value: "Bamanankan", pin: false },
    { name: "Basa Jawa", value: "Basa Jawa", pin: false },
    { name: "Basa Sunda", value: "Basa Sunda", pin: false },
    { name: "Basque", value: "Basque", pin: false },
    { name: "Bengali", value: "Bengali", pin: false },
    { name: "Bhojpuri", value: "Bhojpuri", pin: false },
    { name: "Bislama", value: "Bislama", pin: false },
    { name: "Bosanski Jezik", value: "Bosanski Jezik", pin: false },
    { name: "Bosnian", value: "Bosnian", pin: false },
    { name: "Brezhoneg", value: "Brezhoneg", pin: false },
    { name: "Bulgarian", value: "Bulgarian", pin: false },
    { name: "Burmese", value: "Burmese", pin: false },
    { name: "Cambodian", value: "Cambodian", pin: false },
    { name: "Cantonese", value: "Cantonese", pin: true },
    { name: "Catalan", value: "Catalan", pin: false },
    { name: "Chamoru", value: "Chamoru", pin: false },
    { name: "Chishona", value: "Chishona", pin: false },
    { name: "Corsu", value: "Corsu", pin: false },
    { name: "Croatian", value: "Croatian", pin: false },
    { name: "Cymraeg", value: "Cymraeg", pin: false },
    { name: "Czech", value: "Czech", pin: false },
    { name: "Danish", value: "Danish", pin: false },
    { name: "Dansk", value: "Dansk", pin: false },
    { name: "Deutsch", value: "Deutsch", pin: false },
    { name: "Dhari", value: "Dhari", pin: false },
    { name: "Dutch", value: "Dutch", pin: false },
    { name: "Eesti", value: "Eesti", pin: false },
    { name: "English", value: "English", pin: true },
    { name: "Esperanto", value: "Esperanto", pin: false },
    { name: "Estonian", value: "Estonian", pin: false },
    { name: "Euskara", value: "Euskara", pin: false },
    { name: "Faka Tonga", value: "Faka Tonga", pin: false },
    { name: "Fiji", value: "Fiji", pin: false },
    { name: "Filipino", value: "Filipino", pin: false },
    { name: "Finnish", value: "Finnish", pin: false },
    { name: "Fiteny Malagasy", value: "Fiteny Malagasy", pin: false },
    { name: "Francais", value: "Francais", pin: false },
    { name: "French", value: "French", pin: true },
    { name: "Frysk", value: "Frysk", pin: false },
    { name: "Fulfulde", value: "Fulfulde", pin: false },
    { name: "Gaeilge", value: "Gaeilge", pin: false },
    { name: "Gaelg", value: "Gaelg", pin: false },
    { name: "Galego", value: "Galego", pin: false },
    { name: "Georgian", value: "Georgian", pin: false },
    { name: "German", value: "German", pin: true },
    { name: "Gjuha Shqipe", value: "Gjuha Shqipe", pin: false },
    { name: "Greek", value: "Greek", pin: false },
    { name: "Gujarati", value: "Gujarati", pin: false },
    { name: "Hakka", value: "Hakka", pin: false },
    { name: "Hausa", value: "Hausa", pin: false },
    { name: "Hebrew", value: "Hebrew", pin: false },
    { name: "Hindi", value: "Hindi", pin: false },
    { name: "Hungarian", value: "Hungarian", pin: false },
    { name: "Icelandic", value: "Icelandic", pin: false },
    { name: "Indonesian", value: "Indonesian", pin: false },
    { name: "Irish", value: "Irish", pin: false },
    { name: "Italian", value: "Italian", pin: false },
    { name: "Japanese", value: "Japanese", pin: false },
    { name: "Korean", value: "Korean", pin: false },
    { name: "Latin", value: "Latin", pin: false },
    { name: "Mandarin", value: "Mandarin", pin: true },
    { name: "Marathi", value: "Marathi", pin: false },
    { name: "Nepali", value: "Nepali", pin: false },
    { name: "Norwegian", value: "Norwegian", pin: false },
    { name: "Pashto", value: "Pashto", pin: false },
    { name: "Persian", value: "Persian", pin: false },
    { name: "Polish", value: "Polish", pin: false },
    { name: "Portuguese", value: "Portuguese", pin: false },
    { name: "Punjabi", value: "Punjabi", pin: false },
    { name: "Romanian", value: "Romanian", pin: false },
    { name: "Russian", value: "Russian", pin: false },
    { name: "Spanish", value: "Spanish", pin: true },
    { name: "Swedish", value: "Swedish", pin: false },
    { name: "Tagalog", value: "Tagalog", pin: false },
    { name: "Tamil", value: "Tamil", pin: false },
    { name: "Telugu", value: "Telugu", pin: false },
    { name: "Thai", value: "Thai", pin: false },
    { name: "Turkish", value: "Turkish", pin: false },
    { name: "Ukranian", value: "Ukranian", pin: false },
    { name: "Urdu", value: "Urdu", pin: false },
    { name: "Vietnamese", value: "Vietnamese", pin: false },
    { name: "Welsh", value: "Welsh", pin: false },
    { name: "Zulu", value: "Zulu", pin: false }
];


export const qualifications = [
    { name: 'Certificate IV in Mortgage Broking', value: 'Certificate IV in Mortgage Broking', pin: false },
    { name: 'Diploma of Finance and Mortgage Broking', value: 'Diploma of Finance and Mortgage Broking', pin: false },
    { name: 'RG146', value: 'RG146', pin: false },
    { name: 'Financial Planner', value: 'Financial Planner', pin: false },
    { name: 'Accountant', value: 'Accountant', pin: false },
    { name: 'Other', value: 'Other', pin: false }
];

export const associations = [
    { name: 'FBAA', value: 'FBAA', pin: false },
    { name: 'MFAA', value: 'MFAA', pin: false },
    { name: 'CAFBA', value: 'CAFBA', pin: false },
    { name: 'Other', value: 'Other', pin: false },
];

export const radiusOptions = [15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75];

export const aggregators = [
    { id: '1', business_name: 'AFG (Australian Finance Group)' },
    { id: '2', business_name: 'Astute Financial' },
    { id: '3', business_name: 'Aussie Home Loans' },
    { id: '4', business_name: 'Brokers on Aggregation (BOA)' },
    { id: '5', business_name: 'Choice Aggregation Services (Lendi Group)' },
    { id: '6', business_name: 'Connective' },
    { id: '7', business_name: 'Cube Central' },
    { id: '8', business_name: 'Custom Equity Group' },
    { id: '9', business_name: 'FAST (Finance & Systems Technology, Lendi Group)' },
    { id: '10', business_name: 'FinancePath' },
    { id: '11', business_name: 'Finsure Group' },
    { id: '12', business_name: 'Fintelligence' },
    { id: '13', business_name: 'Launch Finance' },
    { id: '14', business_name: 'Lendi Group' },
    { id: '15', business_name: 'Liberty Network Services' },
    { id: '16', business_name: 'Loan Market Group' },
    { id: '17', business_name: 'MoneyQuest' },
    { id: '18', business_name: 'Mortgage Choice' },
    { id: '19', business_name: 'National Mortgage Brokers (nMB)' },
    { id: '20', business_name: 'NextGen.Net' },
    { id: '21', business_name: 'Outsource Financial' },
    { id: '22', business_name: 'PLAN Australia (Lendi Group)' },
    { id: '23', business_name: 'Purple Circle Financial Services' },
    { id: '24', business_name: 'Redrock Group' },
    { id: '25', business_name: 'Simplicity Loans & Advisory' },
    { id: '26', business_name: 'Smartline' },
    { id: '27', business_name: 'Specialist Finance Group (SFG)' },
    { id: '28', business_name: 'Vow Financial' },
    { id: '29', business_name: 'Yellow Brick Road' },
];

export const hearFromOptions = [
    'Google/Search Engine',
    'Social Media',
    'Word of Mouth',
    'Email Newsletter',
    'Industry Event',
    'Advertisement',
    'Existing Hash Financial Group User',
    'Other',
];

//export const hfg_host = 'https://hashfinancialgroup.com';

export const captchaURL = "https://www.google.com/recaptcha/api.js?render=" + reCaptchaKey;